import { render } from "./RoleManagement.vue?vue&type=template&id=4740f39a&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=4740f39a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4740f39a"]])

export default __exports__